export const Tags = {
    Accountant: 'Accountant',
    AccountantMeetings: 'AccountantMeetings',
    AdditionalCharges: 'AdditionalCharges',
    AgentAuthorisations: 'AgentAuthorisations',
    Companies: 'Companies',
    CompanyOfficers: 'CompanyOfficers',
    CompanyReturns: 'CompanyReturns',
    CompanyReturnFiles: 'CompanyReturnFiles',
    CompanyReturnPrice: 'CompanyReturnPrice',
    OffPlatfromServiceRequests: 'OffPlatformServiceRequests',
    PaymentRequest: 'PaymentRequest',
    Subscriptions: 'Subscriptions',
    SubscriptionTiers: 'SubscriptionTiers',
    TaxConsultationPrice: 'TaxConsultationPrice',
    TaxReliefClaims: 'TaxReliefClaims',
    TaxReliefClaimFiles: 'TaxReliefClaimFiles',
    UnregisteredUser: 'UnregisteredUser',
    UserDiscounts: 'UserDiscounts',
    UserExperiments: 'UserExperiments',
    UserSegments: 'UserSegments',
    Referrals: 'Referrals',
    SelfAssessmentPrice: 'SelfAssessmentPrice',
    TaxReturns: 'TaxReturns',
    TaxReturnReasons: 'TaxReturnReasons',
    TaxRegistration: 'TaxRegistration',
    Partner: 'Partner',
    TaxReturnCapitalGains: 'TaxReturnCapitalGains',
    TaxReturnDividendsAndInterests: 'TaxReturnDividendsAndInterests',
    TaxReturnForeignIncomeSummary: 'TaxReturnForeignIncomeSummary',
    TaxReturnPensionsAndBenefits: 'TaxReturnPensionsAndBenefits',
    TaxReturnPropertyIncome: 'TaxReturnPropertyIncome',
    TaxReturnSelfEmployment: 'TaxReturnSelfEmployment',
    TaxReturnSelfEmploymentExpenses: 'TaxReturnSelfEmploymentExpenses',
} as const
